import React from 'react';
import { RowExpansionToggle } from './row_expansion_toggle.js';
import { CellWrapper } from './cell_wrapper.js';
export function Cell({ cell, column, row, last = false }) {
    return (React.createElement(CellWrapper, { cell: cell, last: last }, cell.isGrouped ? (
    // If it's a grouped cell, add an expander and row count
    React.createElement(React.Fragment, null,
        !column.customExpansionToggle && (React.createElement("span", { className: "twds-flex-none" },
            React.createElement(RowExpansionToggle, { row: row }))),
        cell.render('Cell'),
        !column.customGroupCount && React.createElement("span", { className: "twds-flex-none twds-pl-1" },
            "(",
            row.subRows.length,
            ")"))) : cell.isAggregated ? (
    // If the cell is aggregated, use the Aggregated
    // renderer for cell
    cell.render('Aggregated')) : cell.isPlaceholder ? null : ( // For cells with repeated values, render null
    // Otherwise, just render the regular cell
    cell.render('Cell'))));
}
//# sourceMappingURL=cell.js.map